import { render, staticRenderFns } from "./bankCardBinding.vue?vue&type=template&id=9d989bbc&scoped=true"
import script from "./bankCardBinding.vue?vue&type=script&lang=js"
export * from "./bankCardBinding.vue?vue&type=script&lang=js"
import style0 from "./bankCardBinding.vue?vue&type=style&index=0&id=9d989bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d989bbc",
  null
  
)

export default component.exports